import { BaSeTheme } from '@base/react';
import styled, { css } from 'styled-components';
import GraphBottom from '../../../assets/graph-bottom.png';
import GraphTop from '../../../assets/graph-top.png';

const handleQueryMobile = (style) => {
  return `
    ${BaSeTheme.breakpoints.mobileLarge.mediaQueryCss(style)};
    ${BaSeTheme.breakpoints.mobile.mediaQueryCss(style)};
    ${BaSeTheme.breakpoints.mobileSmall.mediaQueryCss(style)};

  `;
};

const handleQueryDesktop = (style) => {
  return `
    ${BaSeTheme.breakpoints.desktop.mediaQueryCss(style)};
    ${BaSeTheme.breakpoints.desktopLarge.mediaQueryCss(style)};
    ${BaSeTheme.breakpoints.tablet.mediaQueryCss(style)};

  `;
};

export const Container = styled.div`
  background-color: #000;
  /* background-image: url(${GraphTop}); */
  background-repeat: no-repeat;

  background: url(${GraphTop}) no-repeat top right,
    url(${GraphBottom}) no-repeat bottom left;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  ${handleQueryMobile(css`
    background-color: #000;
  `)}

  ${handleQueryDesktop(css`
    background-color: #000;
  `)}
`;

export const Header = styled.div`
  display: grid;
  gap: 8px;
  align-items: center;
`;

export const Content = styled.div`
  width: 75%;

  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
  background-color: #fff;
  border-radius: 4px;
  padding: 24px;
  margin: 24px;
`;

export const ContentWarp = styled.div`
  width: 100%;
  gap: 40px;

  display: flex;
  flex-direction: column;
`;
